import {
  TextFilter,
  TableAbstract
} from "shared/components/Components";

import { useMercuryContext } from "../../context";

import {
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import TimezoneConverter from "components/timezone-converter";

import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import { descriptionColumn, titleColumn } from "shared/table/columnsConfig";
import { activeFilter, createdAtFilter } from "../../filters/filtersConfig";
import AddPoType from "manage/po-types/AddPoType";
import EditPoType from "manage/po-types/EditPoType";
import PermissionWrapper from "shared/components/PermissionWrapper";
import { checkPermissions } from "common/utils/checkPermissions";


class ManagePOTypes extends TableAbstract<any> {
  defaultSortField = "title";
  FilterComponents = [
    {
      id: "title",
      name: "title",
      title: "Title",
      component: TextFilter,
      active: true
    },
    createdAtFilter,
    activeFilter,
  ];

  columns = [
    titleColumn,
    descriptionColumn,
    {
      id: "createdAt",
      title: "Creation Timestamp",
      dataIndex: "createdAt",
      sorter: true,
      fixed: undefined,
      width: 160,
      render: (text: string) => <TimezoneConverter date={text} />
    },
    {
      id: 'isActive',
      title: "Active",
      dataIndex: "isActive",
      width: 75,
      sorter: true,
      fixed: undefined,
      render: (text: string, record: any) =>
        record.isActive ? (
          <CheckOutlined style={{ color: "var(--tertiary-color)" }} />
        ) : (
          <CloseOutlined style={{ color: "var(--red)" }} />
        ),
    }
  ];



  renderActions() {
    const userPermissions = this.userContext.userDetails?.permissions || [];
    // const hasCreateAccess = checkPermissions(userPermissions, [
    //   { customerApplication: "Google", permissionName: "Manage PO Types", action: "create" },
    // ]);
    const hasCreateAccess = true;
    // const hasEditAccess = checkPermissions(userPermissions, [
    //   { customerApplication: "Google", permissionName: "Manage PO Types", action: "edit" },
    // ]);
    const hasEditAccess = true;
    const selectedRows = this.state.selectedRows;
    const isExactlyOneRowSelected = selectedRows?.length === 1;

    const addTooltip =
      !hasCreateAccess ? "No permission to add a new PO Type." : "";

    const editTooltip =
      !hasEditAccess
        ? "No permission to edit a PO Type."
        : !isExactlyOneRowSelected
          ? "Select 1 row to enable edit option"
          : "";

    return (
      <>
        <PermissionWrapper
          tooltip={addTooltip}
          hasPermissions={hasCreateAccess}
          children={
            <AddPoType
              reload={this.getData}
              disabled={!hasCreateAccess}
              hasPermissions={hasCreateAccess}
            />
          }
        />
        <span style={{ display: "inline-block", width: 12 }} />
        <PermissionWrapper
          tooltip={editTooltip}
          hasPermissions={hasEditAccess && isExactlyOneRowSelected}
          children={
            <EditPoType
              currentPoType={selectedRows?.[0]}
              reload={this.getData}
              disabled={!hasEditAccess || !isExactlyOneRowSelected}
              hasPermissions={hasEditAccess && isExactlyOneRowSelected}
            />
          }
        />
      </>
    );
  }


  rowClassName = (record: any): string => {
    return 'row'
  }


   async fetch(): Promise<any> {
    const { sortOrder, sortField, currentPage, itemsPerPage } = this.state;

    const requestPayload = {
      filter: this.filtersToQuery(),
      pagination: {
        pageNumber: currentPage || 1,
        resultsPerPage: itemsPerPage,
      },
      sort: {
        [sortField || "title"]: sortOrder === "ascend" ? 1 : -1,
      },
    };

    const response = await this.userContext.gpClient.post("google-gp-v1/PoType/search", requestPayload);
    
    const documents: any[] = response?.data?.documents || [];
    const meta = response?.data?.meta ?? {
      total: 0,
      page: currentPage,
      pages: 1,
      skip: 0,
      limit: itemsPerPage,
      match: {},
      sort: { createdAt: -1 },
    };

    return {
      data: {
        documents: documents,
        meta
      },
    };
  }

  pageTitle = "Manage PO Types - Mercury";
  title = "Manage PO Types";
  pageClass = "poTypesTable"
}

export default function POTypes() {
  const
    context = useMercuryContext(),
    breaks = useBreakpoint();
  //@ts-ignore
  return <ManagePOTypes id={"ManagePoTypes"} context={context as any} useLegacyEndpoints={false} breaks={breaks as any} hasSidebar={true} />
}
